import React from 'react';

export default function GeradorOrcamento() {
  return <div>Página não econtrada</div>;
}
